// The canonical "which places are medals, and what do we call them" source —
// FinalResultModule (CSS class name) and OverviewModule (emoji) used to
// each hardcode their OWN independent {1, 2, 3} map; both now derive their
// own presentation from this ONE place-to-name mapping instead.
const MEDAL_NAMES = { 1: 'gold', 2: 'silver', 3: 'bronze' };

export const MEDAL_PLACES = [1, 2, 3];

export const medalName = place => MEDAL_NAMES[place];
